import React, { useEffect, useRef, useState } from "react";
import "react-calendar/dist/Calendar.css";
import { Button, Container, Pagination, Table } from "react-bootstrap";
import search_icon from "../assets/search_icon.svg";
import { default as ReactSelect } from "react-select";
import "./Main.scss";

import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faPlus,
  faDownload,
  faSort,
  faEdit,
  faRefresh,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import SidebarContent from "./Sidebar";
import CryptoJS from "crypto-js";
import Papa from "papaparse"; // Import PapaParse library
import TableStatus from "./TableStatus";
import axiosInstance from "../utils/axiosInstance";
import axios from "axios";
// const apiEN = process.env.REACT_APP_GES1;
const apiDE = process.env.REACT_APP_GES3;

export default function Merchants() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [selectedSearchFilter, setSelectedSearchFilter] = useState(null);
  const [isDateConstVisible, setIsDateConstVisible] = useState(false);
  const [isSortFieldDBVisible, setisSortFieldDBVisible] = useState(false);
  const [SortFieldDB, setSortFieldDB] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [DateConst, setDateConst] = useState(new Date());
  const [totalCount, setTotalCount] = useState(0);
  const [selectedFile, setselectedFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [columns, setcolumns] = useState([
    "merchantId",
    "name",
    "email",
    "phone",
    "address",
    "state",
    "city",
    "pincode",
    "accountNumber",
    "ifscCode",
    "bankName",
    "branch",
    "validated",
    "createdAt",
    "updatedAt",
  ]);
  const [modalOpen, setModalOpen] = useState(false);
  const [IsUploading, setIsUploading] = useState(false);
  const MerchantKeys = [
    "merchantId",
    "name",
    "email",
    "phone",
    "state",
    "city",
    "pincode",
    "accountNumber",
    "ifscCode",
    "bankName",
    "branch",
  ];

  const handleFileChange = (e) => {
    try {
      console.log(e.target.files[0]);
      setselectedFile(e.target.files[0]);
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpload = async () => {
    setIsUploading(true);
    const file = selectedFile;
    var email = localStorage.getItem("email");
    var keys = MerchantKeys;
    if (!file) {
      console.error("No file selected.");
      setIsUploading(false);
      return;
    }
    if (file.size > 100 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "The selected file exceeds the 100MB size limit.",
        confirmButtonText: "OK",
      });
      setIsUploading(false);
      return;
    }

    let allErrors = []; // Accumulate all errors here

    // Set initial progress
    let progress = 0;

    // Update progress for file reading
    const fileReadProgressRatio = 0.4; // 40% for file reading
    progress += fileReadProgressRatio * 100;
    setProgress(progress);

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        var jsonData = results.data;

        try {
          const sheetKeys = Object.keys(jsonData[0]);
          const missingKeys = keys.filter((key) => !sheetKeys.includes(key));
          if (missingKeys.length > 0) {
            allErrors.push(
              `The following keys are missing in the uploaded file: ${missingKeys.join(
                ", "
              )}`
            );
          }

          // File reading completed, now upload encrypted data
          const options = {
            onUploadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              const uploadProgress = (loaded / total) * 0.6 * 100; // 60% for uploading
              setProgress(progress + uploadProgress);
            },
          };
          const formData = new FormData();
          formData.append("file", file);
          formData.append("fileName", file.name);
          formData.append("fileSize", file.size);
          formData.append("UploadedBy", email);

          // Simulate uploading delay (remove this in production)
          await new Promise((resolve) => setTimeout(resolve, 1000));

          axiosInstance
            .post(
              process.env.REACT_APP_API_LINK + "/v1/uploadDataDuplicatesCheck",
              JSON.stringify(jsonData)
              // formData,
              // options
            )
            .then(async (response) => {
              console.log("Response:", response.data);
              if (response.data.message === "Can Proceed") {
                const response = await axios.post(
                  process.env.REACT_APP_API_LINK + "/v1/bulkMerchantUpload",
                  formData,
                  options
                );
                console.log(response.data);

                if (
                  response.data.message ===
                  "Data received and upserted successfully."
                ) {
                  Swal.fire({
                    title: "Success",
                    text: "File Uploaded Successfully",
                    icon: "success",
                  });
                  fetchData();
                  toggleModal(true);
                }
              } else {
                const duplicates = response.data.duplicates;
                const duplicatescolumns = ["merchantId", "type"];

                // Generate HTML for the table
                let tableHtml =
                  "<table><thead><tr><th>Duplicate Details for below Merchants</th></tr></thead><tbody>";
                tableHtml += duplicates
                  .map(
                    (item, index) =>
                      "<tr key=" +
                      index +
                      ">" +
                      duplicatescolumns
                        .map(
                          (field, fieldindex) =>
                            "<td key=" +
                            fieldindex +
                            ' style="color: #06152B; font-weight: 400; font-size: 0.81rem;">' +
                            `<p style="width: inherit">` +
                            item[field] +
                            "</p>" +
                            "</td>"
                        )
                        .join("") +
                      "</tr>"
                  )
                  .join("");
                tableHtml += "</tbody></table>";

                // Display Swal modal with custom HTML
                Swal.fire({
                  title: "Warning",
                  html: tableHtml,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Proceed with Duplicates",
                  cancelButtonText: "Cancel",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    const response = await axiosInstance.post(
                      process.env.REACT_APP_API_LINK + "/v1/bulkMerchantUpload",
                      formData,
                      options
                    );
                    console.log(response.data);

                    if (
                      response.data.message ===
                      "Data received and upserted successfully."
                    ) {
                      Swal.fire({
                        title: "Success",
                        text: "File Uploaded Successfully",
                        icon: "success",
                      });
                      fetchData();
                      toggleModal(true);
                    }
                  }
                });
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });

          // Update progress to 100% when response is received
          setProgress(100);
        } catch (error) {
          console.error("Error uploading file:", error);
          Swal.fire({
            title: "Error",
            text: "Error Uploading the File",
            icon: "error",
          });
        } finally {
          setIsUploading(false);
          if (allErrors.length > 0) {
            const errorMessage = allErrors
              .map((err) => `<p>${err}</p>`)
              .join("");
            Swal.fire({
              title: "Error",
              html: `<p>
                          Error uploading file:</p>${errorMessage}`,
              icon: "error",
            });
          }
        }
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        setIsUploading(false);
        Swal.fire({
          title: "Error",
          text: "Error Parsing CSV File",
          icon: "error",
        });
      },
    });
  };

  const toggleModal = (close) => {
    setModalOpen(!modalOpen);
    setProgress(0); // Reset progress when modal opens
    if (close === true) {
      setselectedFile(null);
      setModalOpen(false);
    }
  };
  const [sortOrder, setSortOrder] = useState(null);
  const [data, setdata] = useState(null);
  const [editMode, seteditMode] = useState(false);
  const [editedValues, setEditedValues] = useState(
    Array(data?.length).fill({})
  );
  const [EditRow, setEditRow] = useState([]);
  const toggleEditMode = () => {
    seteditMode(!editMode);
  };
  const [addMerchant, setaddMerchant] = useState(false);
  const handleInputChange = (e, field, index, id) => {
    const { value } = e.target;
    console.log(field);
    // Validation: Check if the field is either "pincode" or "store_id" and if the value is a number
    if ((field === "PINCODE" || field === "STORE_ID") && isNaN(Number(value))) {
      // If the value is not a number, you can handle the error here
      console.error(`Invalid input for ${field}: ${value}`);
      // Don't update the state if the input is invalid
      return;
    }
    console.log({
      UPDATE_ID: "id",
    });
    console.log(EditRow);

    setEditRow((prevState) => ({
      ...prevState,
      [field]: value,
      UPDATE_ID: id,
    }));
  };

  const handleEditSubmit = async (index) => {
    try {
      // Extract id from editedValues

      // Encrypt the edited data
      // const encryptedData = CryptoJS.AES.encrypt(
      //   JSON.stringify({
      //     addMerchant: addMerchant,
      //     ...EditRow,
      //   }),
      //   "secret_key"
      // ).toString();
      // console.log(JSON.stringify(EditRow));

      // Send the encrypted data to the backend
      const response = await axiosInstance.post(
        process.env.REACT_APP_API_LINK + `/v1/addOrUpdateMerchant`,
        {
          addMerchant: addMerchant,
          ...EditRow,
        }
      );

      console.log(response.data);

      if (response.data.message === "Merchant updated successfully") {
        Swal.fire({
          title: "Success",
          text: "Merchant updated successfully",
          icon: "success",
        });
        toggleEditMode(index);
        fetchData();
        toggleModal(true);
      }
    } catch (error) {
      console.error("Error submitting edited data:", error);
      Swal.fire({
        title: "Error",
        text: error.response.data.error || "Failed to update Merchant",
        icon: "error",
      });
    }
  };

  const ccList = [
    { value: "merchantId", label: "Merchant ID" },
    { value: "name", label: "Merchant Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "state", label: "State" },
    { value: "city", label: "City" },
    { value: "pincode", label: "Pincode" },
    { value: "accountNumber", label: "Account Number" },
    { value: "ifscCode", label: "IFSC Code" },
    { value: "bankName", label: "Bank Name" },
    { value: "branch", label: "Branch" },
  ];

  const handlePageChange = (value) => {
    setPage(value);
  };
  const pageCount = Math.ceil(totalCount / pageSize);
  const onDateConstChange = (value) => {
    setDateConst(value);
    setIsDateConstVisible(!isDateConstVisible);
  };
  function getDateLabel(date) {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0); // Reset hours, minutes, seconds, and milliseconds

    if (inputDate.toDateString() === today.toDateString()) {
      return "Today";
    } else if (inputDate.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return inputDate.toISOString().substring(0, 10);
    }
  }
  const fetchData = async () => {
    try {
      setIsLoading(true);
      console.log({
        sortField: SortFieldDB,
        searchValue: searchValue,
        searchFilter: selectedSearchFilter,
      });
      await axiosInstance({
        url: process.env.REACT_APP_API_LINK + `/v1/getMerchantData`,
        method: "POST",
        responseType: "json",
        // withCredentials: true,

        data: {
          sortField: SortFieldDB,
          searchValue: searchValue,
          searchFilter: selectedSearchFilter,
          page: page,
          sortOrder: !sortOrder ? "asc" : sortOrder,
        },
      }).then((response) => {
        if (response) {
          var datax = response.data.data;
          console.log("datax");
          console.log(datax);
          // datax = datax.Merchants;
          console.log("in");

          console.log(datax);
          console.log(typeof datax);
          setdata(datax);
          if (datax.length > 0) {
            setTotalCount(response.data.totalCount);
            setcolumns(Object.keys(datax[0]));
          }
        }
      });
    } catch (err) {
      console.log("error fetching ");
      var error = err;
      return alert(
        error.response.data.error ||
          error.response.data.message ||
          "error fetching data"
      );
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  // useEffect(() => {
  //         fetchData(SortFieldDB, searchValue, selectedSearchFilter,page,sortOrder);
  // }, [page]);
  useEffect(() => {
    if (
      SortFieldDB ||
      (searchValue && selectedSearchFilter) ||
      (!searchValue && !selectedSearchFilter)
    ) {
      fetchData();
    }
  }, [SortFieldDB, searchValue, selectedSearchFilter, sortOrder, page]);

  const handleSort = (field) => {
    console.log(field);
    console.log(SortFieldDB);
    console.log(sortOrder);
    if (field === SortFieldDB) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortFieldDB(field);
      setSortOrder("asc");
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= pageCount; i++) {
    pageNumbers.push(i);
  }

  const getPageItems = () => {
    const items = [];

    // Add Prev button
    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => {
          if (page > 1) {
            handlePageChange(page - 1);
          }
        }}
        disabled={page <= 1}
      />
    );

    // Add page numbers
    for (
      let i = Math.max(1, page - 4);
      i <= Math.min(pageCount, page + 5);
      i++
    ) {
      items.push(
        <Pagination.Item
          key={i}
          active={page === i}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Add Next button
    items.push(
      <Pagination.Next
        key="next"
        onClick={() => {
          if (page < pageCount) {
            handlePageChange(page + 1);
          }
        }}
        disabled={page >= pageCount}
      />
    );

    return items;
  };

  const NavV = () => {
    return (
      <p
        className="align-self-end"
        style={{
          padding: "2%",
          display: "flex",
          backgroundColor: "white",
          margin: 0,
          marginTop: "0rem",
          flexDirection: "row",
          alignItems: "center",

          // , marginBottom: 20
        }}
      >
        {"Home > "}
        <p
          className="align-self-end"
          style={{
            margin: 0,
            marginTop: "0rem",
            marginLeft: "0.51rem",
            fontWeight: "700",
          }}
        >
          {"Merchants"}
        </p>
      </p>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: "100%",
        backgroundColor: "#ffffffff",
      }}
    >
      <SidebarContent />

      <>
        {data?.length > 0 && data != null && !isLoading ? (
          <>
            <Container
              fluid
              style={{
                maxWidth: "85%",
                boxSizing: "border-box", // include padding in width
              }}
            >
              <NavV />
              <div
                className="d-flex flex-wrap"
                style={{
                  display: "flex",
                  alignItems: "stretch",
                }}
              >
                <div className="customx-input-group" style={{ maxWidth: 800 }}>
                  <img
                    src={search_icon}
                    alt=""
                    width={40}
                    style={{
                      padding: 10,
                    }}
                    id="basic-addon1"
                  />
                  <input
                    type="text"
                    className="customx-form-control"
                    style={{
                      minWidth: 400,
                    }}
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    placeholder="Search here"
                  />
                </div>

                {modalOpen && (
                  <div className="modalx">
                    <div className="modalx-content">
                      {/* selectedFile input */}
                      <div
                        style={{ alignSelf: "flex-end", cursor: "pointer" }}
                        onClick={toggleModal}
                      >
                        {" "}
                        close
                      </div>

                      <img
                        src="./logo.png"
                        draggable="false"
                        className={"lovin-it2"}
                      />
                      {!IsUploading && (
                        <>
                          {" "}
                          <label htmlFor="fileInput">Choose a file:</label>
                          <input
                            type="file"
                            id="fileInput"
                            accept=".csv"
                            onChange={handleFileChange}
                            style={{ display: "none" }} // Hide the input element
                          />
                          <button
                            className="custButton2"
                            onClick={() =>
                              document.getElementById("fileInput").click()
                            }
                          >
                            Select File
                          </button>
                        </>
                      )}
                      {/* Display selected selectedFile */}
                      {selectedFile && !IsUploading && (
                        <>
                          <p>File: {selectedFile.name}</p>
                          {/* Button to trigger selectedFile upload */}
                          <button
                            className="custButton2"
                            onClick={handleUpload}
                          >
                            Upload File
                          </button>
                        </>
                      )}
                      {/* Upload progress */}
                      {IsUploading && (
                        <div>
                          {/* <h2>Uploading selectedFile...</h2> */}
                          <progress value={progress} max="100"></progress>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {editMode && (
                  <div className="modalx">
                    <div className="modalx-content">
                      {/* selectedFile input */}
                      <label className="editlabel">
                        {addMerchant ? "Add " : "Edit "}Merchant
                      </label>

                      <div className="fields-container">
                        {columns
                          ?.filter(
                            (key) =>
                              !["createdat", "updatedat", "validated"].includes(
                                key.toLowerCase()
                              )
                          )

                          .map((field, fieldindex) => (
                            <div key={fieldindex} className="field-wrapper">
                              <h2 className="modalxh2">{field}</h2>
                              <input
                                type="text"
                                value={EditRow[field] ?? ""} // prevent undefined error
                                disabled={
                                  !addMerchant && field === "merchantId"
                                } // simplified
                                onChange={(e) =>
                                  handleInputChange(
                                    e,
                                    field,
                                    fieldindex,
                                    EditRow["merchantId"]
                                  )
                                }
                                className="input-fieldx"
                              />
                            </div>
                          ))}
                      </div>
                      <br />

                      <button
                        className="custButton2"
                        onClick={handleEditSubmit}
                      >
                        Submit
                      </button>

                      <button className="custButton2" onClick={toggleEditMode}>
                        Close
                      </button>
                    </div>
                  </div>
                )}

                <div
                  className="custButton"
                  onClick={() => {
                    toggleModal();
                  }}
                >
                  <p className="custButton-text">Upload Merchants</p>
                  <FontAwesomeIcon icon={faPlus} className="custButton-icon" />
                </div>

                <button
                  className="custButton"
                  // className="custButton"
                  style={{
                    position: "relative",
                    backgroundColor: "white",
                    border: "none",
                  }}
                  onClick={() => {
                    setisSortFieldDBVisible(!isSortFieldDBVisible);
                  }}
                >
                  <p className="custButton-text">
                    {SortFieldDB ? SortFieldDB : "Select Sort"}
                  </p>
                  <FontAwesomeIcon icon={faSort} className="custButton-icon" />
                  {isSortFieldDBVisible && (
                    <div className="calendar-container">
                      <div className="FilterDropDown-menu">
                        {MerchantKeys.map((key) => (
                          <span
                            key={key}
                            className="FilterDropDown-item-text"
                            onClick={() => {
                              setSortFieldDB(key);
                            }}
                          >
                            {key}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </button>
                {/* <div className="custButton"
                                   onClick={() => downloaddata()}>
                                    <p className="custButton-text">Download</p>
                                    <FontAwesomeIcon icon={faDownload} className="custButton-icon" />
                                </div> */}

                <div
                  className="custButton"
                  onClick={() => {
                    toggleEditMode();
                    setaddMerchant(true);
                  }}
                >
                  <p className="custButton-text">Add Merchant</p>
                  <FontAwesomeIcon icon={faAdd} className="custButton-icon" />
                </div>
                <div className="custButton" onClick={() => fetchData()}>
                  <p className="custButton-text">Refresh</p>
                  <FontAwesomeIcon
                    icon={faRefresh}
                    className="custButton-icon"
                  />
                </div>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table hover fluid responsive>
                  <thead>
                    <tr
                      style={{
                        color: "#809FB8",
                        borderBottomWidth: 1,
                        borderBottomColor: "#b4a7d6",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        height: 50,
                        verticalAlign: "middle",
                      }}
                    >
                      {columns.map((column) => (
                        <th
                          key={column}
                          onClick={() => {
                            // alert(column);
                            handleSort(column);
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {column}
                        </th>
                      ))}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        {columns.map((field, fieldindex) =>
                          field === "validated" ? (
                            <td key={`${fieldindex}`} style={{}}>
                              {" "}
                              <TableStatus text={item[field] + ""} />
                            </td>
                          ) : (
                            <td
                              key={`${fieldindex}`}
                              style={{
                                color: "#06152B",
                                fontWeight: "400",
                                fontSize: "0.81rem",
                              }}
                            >
                              <p>{item[field] + ""}</p>
                            </td>
                          )
                        )}
                        <td
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            className="custButton-icon"
                            onClick={() => {
                              setaddMerchant(false);
                              toggleEditMode(index);
                              setEditRow(item);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  {/* <h1>asdkjnaskds</h1> */}
                </Table>
                {/* Math.ceil(totalCount / pageSize) */}
                <Pagination style={{ float: "right" }}>
                  <Pagination.First onClick={() => handlePageChange(1)} />
                  {getPageItems()}
                  <Pagination.Last
                    onClick={() => handlePageChange(pageCount)}
                  />
                </Pagination>
              </div>
            </Container>
          </>
        ) : isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center",
              height: "70vh",
              backgroundColor: "white",
            }}
          >
            <img src="./logo.png" draggable="false" className="lovin-it" />
            {/* <Spinner animation="border" /> */}
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignSelf: "center",
                alignItems: "center",
                height: "70vh",
                backgroundColor: "white",
              }}
            >
              <h3>No data found</h3>
            </div>
          </>
        )}
      </>
    </div>
  );
}
